import styled from 'styled-components';

interface Props {
  bgColorPreview: string;
  disabled?: boolean;
}

export const ColorPickerCustomerStyled = styled.div<Props>`
  .preview-color {
    width: 40px;
    height: 40px;
    border-radius: 100%;
    border: 1px dotted #999;
    background-color: ${({ bgColorPreview }) => bgColorPreview};
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  }
`;
